export function isSubActive(user) {
  const sub = user?.subscription;
  // Стан ще не завантажений (оптимістичний кадр на маунті) -> НЕ блокуємо на фронті,
  // щоб не мигнути короною підписнику. Бекенд-гейт (402) лишається страховкою.
  if (sub === undefined || sub === null) return true;
  if (sub.access_override === true) return true;
  const status = sub.status;
  if (status === "active" || status === "trialing") {
    const end = sub.current_period_end || sub.trial_end;
    if (!end) return true;
    return new Date(end) > new Date();
  }
  return false;
}

export function isLocked(user) {
  return !isSubActive(user);
}
